import { render, staticRenderFns } from "./RelatedCommend.vue?vue&type=template&id=9a91d650&scoped=true&"
import script from "./RelatedCommend.vue?vue&type=script&lang=js&"
export * from "./RelatedCommend.vue?vue&type=script&lang=js&"
import style0 from "./RelatedCommend.vue?vue&type=style&index=0&id=9a91d650&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a91d650",
  null
  
)

export default component.exports